// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2qvvT","inputWrap":"CustomTip_inputWrap__1ldxx"};